export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        const {
          name
        } = val;
        if (name) {
          this.$store.dispatch('tagsView/addView', val);
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  }
};